import Icon from '../components/Icon.vue'

Icon.register({
  print: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M448 192V77.3C448 68.8 444.6 60.6 438.6 54.6L393.4 9.4C387.4 3.4 379.2 0 370.7 0H96C78.3 0 64 14.3 64 32V192C28.6 192 0 220.7 0 256V368C0 376.8 7.2 384 16 384H64V480C64 497.7 78.3 512 96 512H416C433.7 512 448 497.7 448 480V384H496C504.8 384 512 376.8 512 368V256C512 220.7 483.4 192 448 192zM384 448H128V352H384V448zM384 224H128V64H320V112C320 120.8 327.2 128 336 128H384V224zM432 296C418.8 296 408 285.3 408 272 408 258.7 418.8 248 432 248S456 258.7 456 272C456 285.3 445.3 296 432 296z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/print.js
// module id = jhoS
// module chunks = 144